import { ValidateResult } from "react-hook-form";

const allowedNamePattern = /^[\p{L}\p{M}]+(?: ?['\u2019-]? ?[\p{L}\p{M}]+)* ?['\u2019-]? ?$/u;

const nameValidator = (value: string): ValidateResult => {
  if (!value) {
    return true;
  }

  return allowedNamePattern.test(value) || "invalidNameCharacters";
};

export default nameValidator;